import {Map, List} from 'immutable';

import * as StorageActions from 'actions/Storage';
import * as userSelectionActions from 'actions/UserSelection';

const initialState = Map({
    main: Map({
        sportsExpanded: List()
    }),
    preMatch: Map({
        sportsExpanded: List(),
        leaguesExpanded: List(),
        matchesExpanded: List(),
        lastShown: null
    }),
    live: Map({
        sportsExpanded: List(),
        leaguesExpanded: List(),
        matchesExpanded: List(),
        lastShown: null
    })
});

function toggleListItem(list, item) {
    const id = Number(item.id);

    if (list.includes(id)) {
        list = list.filter(i => (i != id));
    } else {
        list = list.push(id);
    }

    return list;
}

export default function(state = initialState, action = {}) {
    let section, items, data, showMatches, sportId, leagueId, lastShownExists;

    switch (action.type) {
        case StorageActions.LOAD_STORAGE: {
            const userGridSelection = action.data.userGridSelection;
            if (userGridSelection) {
                state = state.mergeDeep(userGridSelection);
            }
            break;
        }

        case userSelectionActions.USER_SELECTION_SHOW_ALL:
            section = action.section;

            if (state.hasIn([section, 'lastShown'])) {
                state = state.setIn([section, 'lastShown'], null);
            }

            return state;

        case userSelectionActions.USER_SELECTION_TOGGLE_SPORT:
            section = action.section;
            data = action.data;
            showMatches = data.showMatches;
            sportId = Number(data.id);

            items = state.getIn([section, 'sportsExpanded']);
            lastShownExists = state.hasIn([section, 'lastShown']);

            if (showMatches && lastShownExists) {
                state = state.setIn([section, 'lastShown'], Map({sportId}));
            }

            if (!showMatches || (showMatches && !items.includes(sportId))) {
                items = toggleListItem(items, data);
                state = state.setIn([section, 'sportsExpanded'], items);
            }

            return state;

        case userSelectionActions.USER_SELECTION_TOGGLE_LEAGUE:
            section = action.section;
            data = action.data;
            showMatches = data.showMatches;
            sportId = Number(data.sportId);
            leagueId = Number(data.id);

            items = state.getIn([section, 'leaguesExpanded']);
            lastShownExists = state.hasIn([section, 'lastShown']);

            if (showMatches && lastShownExists) {
                state = state.setIn([section, 'lastShown'], Map({sportId, leagueId}));
            }

            if (!showMatches || (showMatches && !items.includes(leagueId))) {
                items = toggleListItem(items, data);
                state = state.setIn([section, 'leaguesExpanded'], items);
            }

            return state;

        case userSelectionActions.USER_SELECTION_TOGGLE_MATCH:
            section = action.section;
            data = action.data;

            items = state.getIn([section, 'matchesExpanded']);
            items = toggleListItem(items, data);
            state = state.setIn([section, 'matchesExpanded'], items);

            return state;
    }

    return state;
}


// WEBPACK FOOTER //
// ./js/sport-betting/reducers/userSelectionReducer.js